import { callApi } from '@/api/callApi';
import { GetFilterUrl, showToastNotification } from '@/utility/helper';
import moment from 'moment';
import React from 'react';
import { Range } from 'react-date-range';

interface ExportOptionProp {
  APIPath: string;
  dateRange?: Range;
  status?: string;
  isEmployee?: boolean;
  isStaff?: boolean;
  roleId?: string;
}
const ExportOption: React.FC<ExportOptionProp> = ({
  APIPath,
  dateRange,
  status,
  isStaff,
  isEmployee,
  roleId,
}) => {
  const exportSheet = async () => {
    try {
      const startDate = moment(dateRange?.startDate).format('YYYY-MM-DD');
      const endDate = moment(dateRange?.endDate).format('YYYY-MM-DD');

      const filterQuery = {
        startDate: startDate,
        endDate: endDate,
        status: status,
        isStaff: isStaff,
        isEmployee: isEmployee,
        roleId: roleId,
      };
      const query = GetFilterUrl(filterQuery);
      const PATH = `${APIPath}?${query ? query : ''}`;
      const response = await callApi(PATH, { method: 'POST' });
      if (response instanceof ArrayBuffer) {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const formattedDateTime = moment().format('YYYY-MM-DD_HH-mm-ss');
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `report_${formattedDateTime}.xlsx`;
        link.click();

        URL.revokeObjectURL(link.href);
      } else {
        showToastNotification('danger', 'Failed to download the report');
      }
    } catch (error) {
      const err = error as { message: string };
      // console.log('Error in export sheet', error);
      showToastNotification('danger', err.message);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={() => exportSheet()}
        className="btn-secondary"
      >
        Export
      </button>
    </div>
  );
};

export default ExportOption;
